import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastService } from 'app/services/toast.service';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import * as fromActions from './actions'
import { CanService } from 'app/services/dal/can.service';
import * as fromUser from 'app/state/user/reducer';
import { Store } from '@ngrx/store';


@Injectable()
export class Effects {

  constructor(
    private store: Store,
    private actions$: Actions,
    private service: CanService,
    private toastService: ToastService
  ) { }

  getItems$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.loadItems),
        withLatestFrom(this.store.select(fromUser.selectBarId)),
        mergeMap(([action, barId]) => this.service.getItems(barId)
          .pipe(
            map(items => fromActions.loadItemsSuccess({ items: items })),
            catchError(error => of(fromActions.loadItemsFailure({ error })))
          )
        )
      );
  });



  addItem$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.addItem),
        mergeMap((action) => from(this.service.add(action.item, action.id))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return fromActions.addItemSuccess({ item: action.item });
            }),
            catchError(error => of(fromActions.addItemFailure({ error })))
          )
        )
      );
  });



  updateBeverage$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.updateItem),
        mergeMap((action) => from(this.service.updateItem(action.item))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return fromActions.updateItemSuccess();
            }),
            catchError(error => of(fromActions.updateItemFailure({ error })))
          )
        )
      );
  });

  softUpdate$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.softUpdate),
        mergeMap((action) => from(this.service.softUpdate(action.id, action.data, action.uid))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return fromActions.softUpdateSuccess({ id: action.id, data: action.data });
            }),
            catchError(error => of(fromActions.softUpdateFailure({ error })))
          )
        )
      );
  });


  deleteItem$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.deleteItem),
        mergeMap((action) => from(this.service.delete(action.id))
          .pipe(
            map(() => {
              return fromActions.deleteItemSuccess({ id: action.id });
            }),
            catchError(error => of(fromActions.addItemFailure({ error })))
          )
        )
      );
  });

}
